import _ from 'lodash'
import {
	AnyConceptStatus,
	ConceptStatus,
	SuperconceptStatus
} from "@fusion-advantage/backcompat";

export const isSuperconceptStatus = (status: AnyConceptStatus | null): status is SuperconceptStatus => {
	return _.isObject(status) && ('subconcepts' in status)
}
export const isConceptStatus = (status: AnyConceptStatus | null): status is ConceptStatus => {
	return _.isObject(status) && !isSuperconceptStatus(status)
}
